const dayOfWeek = {
    'sunday': '日曜日',
    'monday': '月曜日',
    'tuesday': '火曜日',
    'wednesday': '水曜日',
    'thursday': '木曜日',
    'friday': '金曜日',
    'saturday': '土曜日'
} as any

const openHourHolidayCheckbox = () => {
    Object.keys(dayOfWeek).map((key) => {
        const checkbox = document.getElementById(`${key}_holiday_checkbox`) as HTMLInputElement;
        checkbox.addEventListener('change', () => {
            openHourHolidayCheckboxHandler(key, checkbox.checked);
        });
    })
}
const openHourHolidayCheckboxHandler = (dayOfWeek: string, checkboxChecked: boolean) => {
    ['open_time', 'close_time'].map((time) => {
        const timeId = document.getElementById(`${dayOfWeek}_${time}`) as HTMLInputElement;
        timeId.disabled = checkboxChecked;
        timeId.value = '';
        if (!checkboxChecked) {
            timeId.value = (time == 'open_time') ? '09:00' : '21:00';
        }
    })
}

const specialHoursCheckbox = () => {
    const specialHoursDivs = document.querySelectorAll('.special-hour');
    specialHoursDivs.forEach((element) => {
        const checkbox = element.querySelector('.special-hour-closed-checkbox') as HTMLInputElement;
        checkbox.addEventListener('change', () => {
            specialHoursCheckboxHandler(element, checkbox.checked);
        });
    })
}

const deleteSpecialHour = () => {
    const specialHoursDivs = document.querySelectorAll('.special-hour');
    specialHoursDivs.forEach((element) => {
        const deleteIcon = element.querySelector('.delete_special_hour') as HTMLInputElement;
        deleteIcon.addEventListener('click', () => {
            element.remove()
        });
    })
}

const specialHoursCheckboxHandler = (element: Element, checkboxChecked: boolean) => {
    ['open_time', 'close_time'].map((time) => {
        const TimeElement = element.querySelector(`.special_hour_${time}`) as HTMLInputElement;
        TimeElement.disabled = checkboxChecked;
        TimeElement.value = '';
        if (!checkboxChecked) {
            TimeElement.value = (time == 'open_time') ? '09:00' : '21:00';
        }
    })
}

const addSpecialHour = () => {
    const addButton = document.getElementById('add_special_hour') as HTMLButtonElement;
    addButton.addEventListener('click', () => {
        const specialHoursElement = document.querySelector('.special-hours');
        if(specialHoursElement){
            addSpecialHourHandler(specialHoursElement);
            specialHoursCheckbox()
            deleteSpecialHour()
        }
    });
}

const addSpecialHourHandler = (element: Element) => {
    const indexElement = document.getElementById('special_hour_index') as HTMLInputElement
    if (indexElement) {
        let index = parseInt(indexElement.value);
        index += 1;
        indexElement.value = (index).toString();
        element.appendChild(specialHourDivElement(index));
    }
}

const specialHourDivElement = (index: number) => {
    const divElement = document.createElement('div');
    divElement.classList.add('special-hour');
    divElement.id = `special_hour_${index}`;

    const inputDateElement = document.createElement('input');
    inputDateElement.classList.add('form-control', 'special_hour_date');
    inputDateElement.type = 'date';
    inputDateElement.name = `special_hour_date_${index}`;
    inputDateElement.id = `special_hour_date_${index}`;
    divElement.appendChild(inputDateElement);

    const inputOpenTimeElement = document.createElement('input');
    inputOpenTimeElement.value = '';
    inputOpenTimeElement.classList.add('form-control', 'special_hour_open_time');
    inputOpenTimeElement.type = 'time';
    inputOpenTimeElement.name = `special_hour_open_time_${index}`;
    inputOpenTimeElement.id = `special_hour_open_time_${index}`;
    inputOpenTimeElement.disabled = true; // disabled 属性を追加
    divElement.appendChild(inputOpenTimeElement);

    divElement.appendChild(document.createTextNode('〜'));

    const inputCloseTimeElement = document.createElement('input');
    inputCloseTimeElement.value = '';
    inputCloseTimeElement.classList.add('form-control', 'special_hour_close_time');
    inputCloseTimeElement.type = 'time';
    inputCloseTimeElement.name = `special_hour_close_time_${index}`;
    inputCloseTimeElement.id = `special_hour_close_time_${index}`;
    inputCloseTimeElement.disabled = true; // disabled 属性を追加
    divElement.appendChild(inputCloseTimeElement);

    const inputCheckboxElement = document.createElement('input');
    inputCheckboxElement.classList.add('special-hour-closed-checkbox');
    inputCheckboxElement.type = 'checkbox';
    inputCheckboxElement.value = 'true';
    inputCheckboxElement.checked = true;
    inputCheckboxElement.name = `special_hour_closed_checkbox_${index}`;
    inputCheckboxElement.id = `special_hour_closed_checkbox_${index}`;
    divElement.appendChild(inputCheckboxElement);

    const labelElement = document.createElement('label');
    labelElement.htmlFor = 'special_hour_closed';
    labelElement.textContent = '休業';
    divElement.appendChild(labelElement);

    const iElement = document.createElement('i');
    iElement.classList.add('fa', 'fa-trash', 'delete_special_hour');
    iElement.id = `delete_special_hour_${index}`;
    divElement.appendChild(iElement);
    return divElement

}
const editInit = () => {
    Object.keys(dayOfWeek).map((key) => {
        const openTimeId = document.getElementById(`${key}_open_time`) as HTMLInputElement;
        const closeTimeId = document.getElementById(`${key}_close_time`) as HTMLInputElement;
        if (openTimeId.value == '' || closeTimeId.value == '') {
            const checkbox = document.getElementById(`${key}_holiday_checkbox`) as HTMLInputElement;
            checkbox.checked = true;
            openTimeId.disabled = true;
            openTimeId.value = '';
            closeTimeId.disabled = true;
            closeTimeId.value = '';
        }
    })
    const specialHoursDivs = document.querySelectorAll('.special-hour');
    specialHoursDivs.forEach((element) => {
        const closedChecked = element.querySelector('.special-hour-closed-checkbox') as HTMLInputElement;
        if (closedChecked.checked) {
            const specialHourOpenTime = element.querySelector('.special_hour_open_time') as HTMLInputElement;
            specialHourOpenTime.disabled = true;
            specialHourOpenTime.value = '';
            const specialHourCloseTime = element.querySelector('.special_hour_close_time') as HTMLInputElement;
            specialHourCloseTime.disabled = true;
            specialHourCloseTime.value = '';
        }
    })
}
document.addEventListener('DOMContentLoaded', () => {

    const GbpLocationEdit = document.getElementById('gbp_location_edit') as HTMLElement;
    if (GbpLocationEdit == null) {
        return;
    }

    editInit();
    openHourHolidayCheckbox()
    specialHoursCheckbox()
    deleteSpecialHour()
    addSpecialHour()
});
